export default {
  USER_ID: process.env.REACT_APP_EMAIL_USER_ID, //userID,
  SERVICE_ID: process.env.REACT_APP_EMAIL_SERVICE_ID,
  TEMPLATE_ID: `template_o12z0wh`, //templateID
};
